import { Component } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import {
  ImageCropperComponent,
  ImageCroppedEvent,
  LoadedImage,
} from 'ngx-image-cropper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '../../settings/settings.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-upload-avatar',
  standalone: true,
  imports: [MaterialModule, CommonModule, ImageCropperComponent],
  templateUrl: './upload-avatar.component.html',
  styleUrl: './upload-avatar.component.less',
})
export class UploadAvatarComponent {
  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl = '';
  name_img: string = '';
  token: any;
  previousImage: SafeUrl | null = null;

  loading:boolean=false;
  disabled:boolean=true;

  constructor(
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public settings: SettingsService,
    public dialogRef: MatDialogRef<UploadAvatarComponent>,
    private sanitizer: DomSanitizer
  ) {}

  change_avatar() {
    const fileInput = document.getElementById('input-avatar') as HTMLElement;
    fileInput.click();
  }

  fileChangeEvent(event: Event): void {
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0]; 
      this.name_img = file.name;
      this.imageChangedEvent = event; 
      this.previousImage = this.croppedImage; 
    } else {
      if (this.previousImage) {
        this.croppedImage = this.previousImage; 
      }
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    if (event.objectUrl) {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
      this.blob_image = event.blob; 
      console.log("Blob de la imagen recortada:", this.blob_image);
    }
  }
  imageLoaded(image: LoadedImage) {
    this.disabled = false;
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  type_image: number= 2;
  blob_image: any;

  async envia_form() {
    try {
      this.loading = true;
      this.disabled = true;
  
      let value = new FormData();
      value.append('image', this.blob_image, "imagen.png");
      value.append('type', this.type_image.toString());
  
      console.log("FormData enviado:", value);
  
      const bd: any = await this.settings.get_query(3, "/cliente-inversionista/image/", value);
      var body_data: any = bd._body;
  
      console.log("Respuesta del servidor:", bd);
  
      switch (bd.status) {
        case 200:
        case 201:
          this.snackBar.open('Imagen de perfil actualizada', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack'
          });
          this.dialogRef.close(true);
          this.loading = false;
          this.disabled = false;
          break;
        default:
          console.error("Error en la respuesta del servidor", bd);
          break;
      }
    } catch (bd: any) {
      this.loading = false;
      this.disabled = false;
  
      console.error("Error en el catch:", bd);
  
      switch (bd.status) {
        case 500:
        case 400:
          this.snackBar.open('Ocurrió un error desconocido, intenta de nuevo', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack'
          });
          break;
        case 401:
          this.snackBar.open('¡Hola! Parece que tu sesión ha expirado. Por favor, inicia sesión nuevamente para continuar', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack'
          });
          break;
        default:
          this.snackBar.open('Ocurrió un error desconocido, intenta de nuevo', 'Aceptar', {
            duration: 20000,
            panelClass: 'simpli-snack'
          });
          break;
      }
    }
  }
  
}
